import { useAuth } from './AuthProvider'
import { SeguruSymbol } from '../components/SeguruSymbol'

export function LoginPage() {
  const { signInWithGoogle } = useAuth()

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ background: 'var(--bg)', fontFamily: 'var(--font-ui)' }}>
      <div className="w-full max-w-xs px-4">

        <div className="mb-10">
          <div className="mb-6 flex items-center gap-2.5" style={{ fontFamily: 'var(--font-display)', fontSize: '26px', fontWeight: 400, letterSpacing: '-0.02em', color: 'var(--ink-1)' }}>
            <SeguruSymbol size={32} />
            <span>seGuru</span>
          </div>
          <h1 className="text-2xl leading-tight" style={{ fontFamily: 'var(--font-display)', fontWeight: 300, fontSize: '34px', letterSpacing: '-0.02em', color: 'var(--ink-1)' }}>
            O teu assistente<br />de produtividade.
          </h1>
          <p className="mt-2 text-sm" style={{ color: 'var(--ink-3)' }}>Gestão de conhecimento e foco diário.</p>
        </div>

        <button
          onClick={signInWithGoogle}
          className="flex items-center justify-center w-full gap-3 px-4 py-3 text-sm font-medium rounded-sm transition-colors cursor-pointer"
          style={{ background: 'var(--ink-1)', color: '#fff', border: '1px solid var(--ink-1)' }}
          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--accent)'; (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--accent)' }}
          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--ink-1)'; (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--ink-1)' }}
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
          </svg>
          Entrar com Google
        </button>

        <p className="mt-4 text-xs text-center" style={{ color: 'var(--ink-3)' }}>
          Ao entrar, aceitas os nossos termos de serviço.
        </p>
      </div>
    </div>
  )
}
